/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ControlConfiguration } from './ControlConfiguration';
import {
	ControlConfigurationFromJSON,
	ControlConfigurationFromJSONTyped,
	ControlConfigurationToJSON,
	ControlConfigurationToJSONTyped,
} from './ControlConfiguration';
import type { EventConfiguration } from './EventConfiguration';
import {
	EventConfigurationFromJSON,
	EventConfigurationFromJSONTyped,
	EventConfigurationToJSON,
	EventConfigurationToJSONTyped,
} from './EventConfiguration';
import type { EasyClaimAppState } from './EasyClaimAppState';
import {
	EasyClaimAppStateFromJSON,
	EasyClaimAppStateFromJSONTyped,
	EasyClaimAppStateToJSON,
	EasyClaimAppStateToJSONTyped,
} from './EasyClaimAppState';

/**
 *
 * @export
 * @interface EasyClaimFrontendStep
 */
export interface EasyClaimFrontendStep {
	/**
	 *
	 * @type {EasyClaimAppState}
	 * @memberof EasyClaimFrontendStep
	 */
	appState?: EasyClaimAppState;
	/**
	 *
	 * @type {number}
	 * @memberof EasyClaimFrontendStep
	 */
	order?: number;
	/**
	 *
	 * @type {Array<ControlConfiguration>}
	 * @memberof EasyClaimFrontendStep
	 */
	controlsConfigurations?: Array<ControlConfiguration> | null;
	/**
	 *
	 * @type {Array<EventConfiguration>}
	 * @memberof EasyClaimFrontendStep
	 */
	eventConfigurations?: Array<EventConfiguration> | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimFrontendStep
	 */
	readonly isLogoVisible?: boolean;
}

/**
 * Check if a given object implements the EasyClaimFrontendStep interface.
 */
export function instanceOfEasyClaimFrontendStep(value: object): value is EasyClaimFrontendStep {
	return true;
}

export function EasyClaimFrontendStepFromJSON(json: any): EasyClaimFrontendStep {
	return EasyClaimFrontendStepFromJSONTyped(json, false);
}

export function EasyClaimFrontendStepFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EasyClaimFrontendStep {
	if (json == null) {
		return json;
	}
	return {
		appState: json['appState'] == null ? undefined : EasyClaimAppStateFromJSON(json['appState']),
		order: json['order'] == null ? undefined : json['order'],
		controlsConfigurations:
			json['controlsConfigurations'] == null
				? undefined
				: (json['controlsConfigurations'] as Array<any>).map(ControlConfigurationFromJSON),
		eventConfigurations:
			json['eventConfigurations'] == null
				? undefined
				: (json['eventConfigurations'] as Array<any>).map(EventConfigurationFromJSON),
		isLogoVisible: json['isLogoVisible'] == null ? undefined : json['isLogoVisible'],
	};
}

export function EasyClaimFrontendStepToJSON(json: any): EasyClaimFrontendStep {
	return EasyClaimFrontendStepToJSONTyped(json, false);
}

export function EasyClaimFrontendStepToJSONTyped(
	value?: Omit<EasyClaimFrontendStep, 'isLogoVisible'> | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		appState: EasyClaimAppStateToJSON(value['appState']),
		order: value['order'],
		controlsConfigurations:
			value['controlsConfigurations'] == null
				? undefined
				: (value['controlsConfigurations'] as Array<any>).map(ControlConfigurationToJSON),
		eventConfigurations:
			value['eventConfigurations'] == null
				? undefined
				: (value['eventConfigurations'] as Array<any>).map(EventConfigurationToJSON),
	};
}
